/**
 * Composing css class
 * @param classes string
 * @returns string
 */
export function cn(...classes: string[]) {
    return classes.join(' ');
}